var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMe, useUserInitials } from '@/ui/modules/shared/hooks';
import { useCallback } from 'react';
import { Avatar, AvatarSize } from '@agentguru/components';
import { useBottomNavBar } from '@agentguru/layout';
import styles from './BottomNavBarUserProfile.module.scss';
export function BottomNavBarUserProfile() {
    var _a;
    var _b = useBottomNavBar(), setShowRoutesModal = _b.setShowRoutesModal, setCurrentRouteByKey = _b.setCurrentRouteByKey;
    var userNameInitials = useUserInitials();
    var data = useMe().data;
    var user = data === null || data === void 0 ? void 0 : data.getUser;
    var handleNavigateProfile = useCallback(function () {
        setShowRoutesModal(true);
        setCurrentRouteByKey(1);
    }, [setCurrentRouteByKey, setShowRoutesModal]);
    return (_jsxs("button", __assign({ className: styles.userProfileContainer, onClick: handleNavigateProfile, type: "button" }, { children: [_jsxs("div", __assign({ className: styles.container }, { children: [_jsx(Avatar, { variant: AvatarSize.md, userNameInitials: userNameInitials, avatarUri: ((_a = user === null || user === void 0 ? void 0 : user.avatar) === null || _a === void 0 ? void 0 : _a.small_uri) || '' }), _jsxs("div", { children: [_jsx("h3", { children: "".concat(user === null || user === void 0 ? void 0 : user.first_name, " ").concat((user === null || user === void 0 ? void 0 : user.middle_name) || '', " ").concat(user === null || user === void 0 ? void 0 : user.last_name) }), _jsx("span", { children: user === null || user === void 0 ? void 0 : user.email })] })] })), _jsx("i", { className: "icon-ag-arrow-right" })] })));
}
